function RegisterHandlebarsHelpers(labels) {
  const self = this;

  Handlebars.registerHelper('selected', function (context) {
    return String(context.hash.first) === String(context.hash.second) ? 'selected' : '';
  })

  Handlebars.registerHelper('amount', function (rawAmount) {
    return new Handlebars.SafeString(Formats.amountWithCurrency(rawAmount))
  })

  Handlebars.registerHelper('amountWithoutCurrency', function (rawAmount, decimalPlaces) {
    return new Handlebars.SafeString(Formats.amountWithoutCurrency(rawAmount, decimalPlaces))
  })

  Handlebars.registerHelper('roundedAmount', function (amount) {
    return new Handlebars.SafeString(Formats.splitThousandsWithSpaces(amount.toFixed(0)))
  })

  self._labelOrDefault = function (key, defaultText, context) {
    return !!labels[key] ? self._label(key, context) : defaultText
  }

  self._label = function (key, context) {
    const hash = context.hash;
    const translation = labels[key]

    if (translation && hash) {
      let objectEntries = [];
      for(var value in hash) {
        objectEntries.push([value, hash[value]])
      }

      return objectEntries
        .reduce(function (memo, entry) {
          return memo.replace(new RegExp('\\{' + entry[0] + '\\}', 'g'), entry[1])
        }, translation);
    }

    Logger.error('Translation missing: "' + key + '"')
    return key;
  }

  self._labelRoundedNumbers = function (key, context) {
    const hash = context.hash;
    const translation = labels[key]

    if (translation && hash) {
      let objectEntries = [];
      for(var value in hash) {
        objectEntries.push([value, hash[value]])
      }

      return objectEntries
        .reduce(function (memo, entry) {
          let value = isNaN(entry[1]) ? entry[1] : entry[1].toFixed(0)
          value = value === undefined ? entry[1] : value
          return memo.replace(new RegExp('\\{' + entry[0] + '\\}', 'g'), value)
        }, translation);
    }

    Logger.error('Translation missing: "' + key + '"')
    return key;
  }

  Handlebars.registerHelper('label', self._label);
  Handlebars.registerHelper('labelOrDefault', self._labelOrDefault);
  Handlebars.registerHelper('labelRoundedNumbers', self._labelRoundedNumbers);

  Handlebars.registerHelper('percentage', function (total, fraction) {
    return Formats.percentage(total, fraction);
  })

  Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
    return (arg1 === arg2) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('formatDate', function (date) {
    return new Date(date).toLocaleDateString('et-EE')
  })

  Handlebars.registerHelper('setChecked', function (currentValue, value) {
    return value == currentValue ? 'checked' : ''
  })
}
